export default "__VITE_ASSET__DYrkRI3C__"